'use strict'

import React from 'react';
import uuid from 'uuid';
import Field from '../components/Field3.jsx';
import FormattedContent from '../components/FormattedContent.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

export default class ExceptionManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state={showDetails:props.showDetails===true};
  }

  showDetails(event) {
    event.preventDefault();
    this.setState({showDetails:true});
  }

  raiseException(event) {
    event.preventDefault();
    if (this.state.edit===true) {
      sendCommand({
        type:"updateExceptionPlanRequest",
        id: this.props.project.requestedStageException.id,
        project: {id: this.props.project.id},
        summary: event.target.elements.summary.value,
        level: event.target.elements.level.value,
        exceptionReport: event.target.elements.report.value.trim().length>0 ? event.target.elements.report.value : undefined
      })
        .then(response=>{
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(response.project);
          }
          window.location="plan";
        })
        .catch(error=>{
          console.log("[ERROR] An error occured",error);
          alert("An error occured, please try again");
        });
    } else {
      sendCommand({
        type:"raiseException",
        id: uuid.v4(),
        project: {id: this.props.project.id},
        summary: event.target.elements.summary.value,
        level: event.target.elements.level.value,
        exceptionReport: event.target.elements.report.value.trim().length>0 ? event.target.elements.report.value : undefined
      })
        .then(response=>{
          if (this.props.onUpdate!==undefined) {
            this.props.onUpdate(response.project);
          }
          window.location="plan";
        })
        .catch(error=>{
          console.log("[ERROR] An error occured",error);
          alert("An error occured, please try again");
        });
    }
  }

  approveException(event) {
    event.preventDefault();
    var command={
      type:"approveException",
      id: this.props.project.requestedStageException.id,
      project: {id: this.props.project.id},
    };
    if (this.props.project.requestedStageException.stage!==undefined) {
      command.stage={id: this.props.project.requestedStageException.stage.id};
    }
    sendCommand(command)
      .then(response=>{
        if (this.props.onUpdate!==undefined) {
          this.props.onUpdate(response.project);
        }
      })
      .catch(error=>{
        console.log("[ERROR] An error occured",error);
        alert("An error occured, please try again");
      });
  }

  cancelException(event) {
    event.preventDefault();
    window.location="plan";
  }

  edit(event) {
    event.preventDefault();
    this.setState({edit:true});
  }

  render() {
    let labels=translations.getTranslation(this.props).general.exceptionPlan;
    var summary=this.props.project.requestedStageException!==undefined && this.props.project.requestedStageException!==null && this.props.project.requestedStageException.summary!==undefined && this.props.project.requestedStageException.summary!==null ? this.props.project.requestedStageException.summary : "";
    var truncated=false;
    if (this.state.showDetails===false && summary.trim().length>144) {
      summary=summary.slice(0,143);
      summary=summary.slice(0,summary.lastIndexOf(" ")).trim()+"...";
    }
    let level=this.props.project.requestedStageException!==undefined && this.props.project.requestedStageException.level!==undefined
      ? this.props.project.requestedStageException.level
      : "stage";
    let exceptionReport=this.props.project.requestedStageException!==undefined
      && this.props.project.requestedStageException.exceptionReport!==undefined && this.props.project.requestedStageException.exceptionReport!==null
      ? this.props.project.requestedStageException.exceptionReport.id
      : undefined;
    let exceptionStage=this.props.project.requestedStageException!==undefined ? this.props.project.stages.find(stage=>stage.id===this.props.project.requestedStageException.stage.id) : undefined;
    const exceptionLevels=[]
      .concat(this.props.project.currentStage!==undefined ? "stage" : undefined)
      .concat(this.props.project.currentPhase!==undefined ? "phase": undefined)
      .concat("project")
//      .concat(this.props.project.programme!==undefined ? {value: "programme", text:"Programme"} : undefined)
      .filter(item=>item!==undefined)
      .map(item=>({
        value: item,
        text: labels.fields.level.options[item].title || "(."+item+")"
        }));
    const exceptionReports=[{value:"", text:labels.fields.report.empty}]
      .concat(
        [].concat.apply([],this.props.project.issues!==undefined
          ? this.props.project.issues
            .map(issue=>issue.reports!==undefined
              ? issue.reports.map(report=>report.exception
                ? Object.assign({},report,{issue: issue})
                : undefined)
              : undefined
            )
          : undefined
          )
          .filter(item=>item!==undefined && item!==null)
          .map(report=>({value: report.id, text:new Date(report.date).toISOString().slice(0,10)+" "+report.issue.title}))
        );
    return this.props.raiseException===true && this.props.project.currentStage!==undefined || this.state.edit===true ? (
      <form onSubmit={this.raiseException.bind(this)}>
        <div style={{fontFamily:"Lato", marginBottom:20}}>
          <h2>
            <img style={{paddingRight:10, verticalAlign:"middle"}} src="/images/Flag_DarkGrey_22x16.gif"/>
            {labels.title}
            </h2>
            <div style={{backgroundColor:"#f7f7f7", padding:30}}>
              <Field
              title={labels.fields.level.title}
              name="level"
              options={exceptionLevels}
              value={level}
              />
              <Field
              title={labels.fields.report.title}
              name="report"
              options={exceptionReports}
              optional={true}
              value={exceptionReport}
              />
              <Field
              title={labels.fields.summary.title}
              name="summary"
              help={labels.fields.summary.help}
              description={labels.fields.summary.description}
              height="3"
              value={summary}/>
            </div>
            <div style={{paddingTop:15, paddingBottom:20}}>
              <input onClick={this.cancelException.bind(this)} className="cancel" type="button" value={labels.cancel}/>
              <input className="save" type="submit" value={this.state.edit===true ? labels.update : labels.requestApproval}/>
            </div>
        </div>
      </form>
    ) : this.props.project.requestedStageException!==undefined ? (
      <div style={{paddingBottom:20, fontFamily:"Lato"}}>
        {this.props.viewOnly!==true ? (
          <img style={{paddingRight:10, verticalAlign:"middle"}} src="/images/Flag_DarkGrey_22x16.gif"/>
        ) : null}
        <b>{labels.title}</b>
        <span> </span>
        {this.props.project.requestedStageException.level===undefined || this.props.project.requestedStageException.level==="stage" ? (
          <span>({labels.fields.level.options.stage.title}: {this.props.project.requestedStageException!==undefined ? ": "+exceptionStage.name : labels.stageNotFound})</span>
        ) : (
          <span>({labels.fields.level.options[this.props.project.requestedStageException.level].title})</span>
        )
        }
        <span> </span>
        {this.props.viewOnly!==true && this.props.project.requestedStageException.id!==undefined ? (
          <a onClick={this.edit.bind(this)} href="#"><img src="/icons/pen_grey.jpg"/></a>
        ) : null}
        <div>
          <FormattedContent value={summary}/>
        </div>
        {this.state.showDetails===true
          && this.props.project.requestedStageException.exceptionReport!==undefined
          && this.props.project.requestedStageException.exceptionReport!==null ? (
          <div style={{paddingTop:5, paddingBottom:5}}>
            <a target="_blank" href={"/projects/"+this.props.project.id+"/change/issues/"+
              this.props.project.requestedStageException.exceptionReport.issue.id+
              "/reports/"+this.props.project.requestedStageException.exceptionReport.id}>{labels.exceptionReport}</a>
          </div>
        ) : this.props.project.requestedStageException.exceptionReport===undefined ||
            this.props.project.requestedStageException.exceptionReport===null ? (
          <div style={{fontWeight: "bold", color:"red", paddingTop:5,paddingBottom:5}}>
            {labels.missingExceptionReport}
          </div>
        ) : null}
        {this.state.showDetails===true && this.props.baseline!==undefined ? (
          <div style={{paddingBottom:5}}>
            <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+this.props.baseline.version+"/"}>{labels.baselinePlan}</a> {labels.beforeExceptionAproval}
          </div>
        ) : null}
        {this.state.showDetails===true && this.props.approved!==undefined ? (
          <div style={{paddingBottom:5}}>
            <a target="_blank" href={"/projects/"+this.props.project.id+"/plan/baseline/"+this.props.approved.version+"/"}>{labels.newBaselinePlan}</a> {labels.afterExceptionApproval}
          </div>
        ) : null}
        {this.props.viewOnly!==true && this.state.showDetails===true ? (
          <div style={{paddingTop:15, paddingBottom:20}}>
            <input onClick={this.approveException.bind(this)} className="save" type="submit" value={labels.approve}/>
          </div>

        ) : this.props.viewOnly!==true
          ? (
              <div style={{float:"right"}}>
                <a onClick={this.showDetails.bind(this)} href="#">{labels.readMore}</a>
              </div>
            )
          : null
        }
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./views/plan/ExceptionManagement.jsx